import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { Debug } from '@awayjs/core';
// Class: GameInputDevice
var GameInputDevice = /** @class */ (function (_super) {
    __extends(GameInputDevice, _super);
    function GameInputDevice() {
        return _super.call(this) || this;
    }
    Object.defineProperty(GameInputDevice.prototype, "numControls", {
        // _numControls: number /*int*/;
        // _sampleInterval: number /*int*/;
        // _enabled: boolean;
        // _id: string;
        // _name: string;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'get numControls', '');
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "sampleInterval", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'get sampleInterval', '');
            return;
            // return this._sampleInterval;
        },
        set: function (val /*int*/) {
            val = val | 0;
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'set sampleInterval', '');
            // this._sampleInterval = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "enabled", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'get enabled', '');
            // return this._enabled;
            return true;
        },
        set: function (val) {
            val = !!val;
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'set enabled', '');
            // this._enabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "id", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'get id', '');
            return '';
            // return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "name", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputDevice', 'get name', '');
            return '';
            // return this._name;
        },
        enumerable: true,
        configurable: true
    });
    GameInputDevice.prototype.getControlAt = function (i /*int*/) {
        i = i | 0;
        // @todo
        Debug.throwPIR('playerglobals/ui/GameInputDevice', 'getControlAt', '');
        return null;
    };
    GameInputDevice.prototype.startCachingSamples = function (numSamples /*int*/, controls) {
        numSamples = numSamples | 0;
        // @todo
        Debug.throwPIR('playerglobals/ui/GameInputDevice', 'startCachingSamples', '');
        return;
    };
    GameInputDevice.prototype.stopCachingSamples = function () {
        // @todo
        Debug.throwPIR('playerglobals/ui/GameInputDevice', 'stopCachingSamples', '');
        return;
    };
    GameInputDevice.prototype.getCachedSamples = function (data, append) {
        if (append === void 0) { append = false; }
        append = !!append;
        // @todo
        Debug.throwPIR('playerglobals/ui/GameInputDevice', 'getCachedSamples', '');
        return 0;
    };
    // Called whenever the class is initialized.
    GameInputDevice.classInitializer = null;
    // List of static symbols to link.
    GameInputDevice.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputDevice.instanceSymbols = null; // [];
    GameInputDevice.MAX_BUFFER_SIZE = 4800;
    return GameInputDevice;
}(EventDispatcher));
export { GameInputDevice };
